// src/components/AdminLayout.js
import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';
import logo from '../assets/logo.png'; 

// Ícone de seta (Chevron) como um componente SVG para não precisar de bibliotecas
const ChevronIcon = ({ isOpen }) => (
    <svg 
        className={`chevron-icon ${isOpen ? 'open' : ''}`}
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
);


const AdminLayout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Verifica se a rota atual está dentro de "blog" para manter o menu aberto
    const isBlogPathActive = location.pathname.startsWith('/admin/posts') || 
                            location.pathname.startsWith('/admin/categorias') || 
                            location.pathname.startsWith('/admin/autores');

    const [isBlogMenuOpen, setBlogMenuOpen] = useState(isBlogPathActive);
    const isFinanceiroPathActive = location.pathname.startsWith('/admin/financeiro');
    const [isFinanceiroMenuOpen, setFinanceiroMenuOpen] = useState(isFinanceiroPathActive);
    
    const handleLogout = async () => {
    try {
        await logout(); // Chama a função de logout
        navigate('/');   // Redireciona o usuário para a página inicial
    } catch (error) {
        console.error("Falha ao fazer logout", error);
    }
    };

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header" onClick={() => navigate('/admin/dashboard')}>
                    <img src={logo} alt="PTS DEV Logo" className="sidebar-logo" />
                    <h2>Painel Admin</h2>
                </div>
                <nav className="admin-nav">
                    <ul>
                        <li>
                            <NavLink to="/admin/dashboard">Dashboard</NavLink>
                        </li>
                        {/* Item de Menu "Blog" que se expande */}
                        <li className="nav-item">
                            <div 
                                className={`nav-item-toggle ${isBlogPathActive ? 'active-parent' : ''}`}
                                onClick={() => setBlogMenuOpen(!isBlogMenuOpen)}
                            >
                                <span>Blog</span>
                                <ChevronIcon isOpen={isBlogMenuOpen} />
                            </div>
                            {isBlogMenuOpen && (
                                <ul className="submenu">
                                    <li><NavLink to="/admin/posts">Posts</NavLink></li>
                                    <li><NavLink to="/admin/categorias">Categorias</NavLink></li>
                                    <li><NavLink to="/admin/autores">Autores</NavLink></li>
                                </ul>
                            )}
                        </li>
                        {/* --- INÍCIO: NOVO MENU FINANCEIRO ADICIONADO --- */}
                        <li className="nav-item">
                            <div
                                className={`nav-item-toggle ${isFinanceiroPathActive ? 'active-parent' : ''}`}
                                onClick={() => setFinanceiroMenuOpen(!isFinanceiroMenuOpen)}
                            >
                                <span>Financeiro</span>
                                <ChevronIcon isOpen={isFinanceiroMenuOpen} />
                            </div>
                            {isFinanceiroMenuOpen && (
                                <ul className="submenu">
                                    <li>
                                        {/* Este link levará para a página com o botão */}
                                        <NavLink to="/admin/financeiro/cobranca-pix">Gerar Cobrança PIX</NavLink>
                                    </li>
                                </ul>
                            )}
                        </li>
                    </ul>
                </nav>
                <div className="sidebar-footer">
                    <button onClick={handleLogout} className="logout-button">Sair</button>
                </div>
            </aside>
            <main className="admin-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;